import { MEDIA_ADMIN_URL } from './serverConfig';

const TYPE_CODE_TO_CAT_KEY: Record<number, string> = {
  1: 'hospital', 2: 'doctor', 3: 'medical_store', 4: 'homecare',
  5: 'ambulance', 6: 'diagnostic', 7: 'wholesaler', 8: 'blood_bank', 9: 'health_camp',
};

let _cache: Record<string, string> | null = null;
let _pending: Promise<void> | null = null;
const _listeners = new Set<() => void>();

export function preloadCategoryPlaceholders(): Promise<void> {
  if (_cache !== null) return Promise.resolve();
  if (_pending) return _pending;
  _pending = fetch(`${MEDIA_ADMIN_URL}?action=get_placeholders`)
    .then(r => r.json())
    .then(data => {
      _cache = (data.success && data.data) ? data.data : {};
      _listeners.forEach(fn => fn());
    })
    .catch(() => {
      _cache = {};
      _listeners.forEach(fn => fn());
    });
  return _pending;
}

export function getCategoryPlaceholderUrl(typeCode: number): string | null {
  if (!_cache) return null;
  const key = TYPE_CODE_TO_CAT_KEY[typeCode];
  return (key && _cache[key]) || null;
}

import { useState, useEffect } from 'react';

export function useCategoryPlaceholder(typeCode: number): string | null {
  const [, forceUpdate] = useState(0);
  useEffect(() => {
    if (_cache === null) {
      const notify = () => forceUpdate(n => n + 1);
      _listeners.add(notify);
      preloadCategoryPlaceholders();
      return () => { _listeners.delete(notify); };
    }
  }, []);
  return getCategoryPlaceholderUrl(typeCode);
}
